export const mixin = {
  data() {
    return {
      orderInfoConfig: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '客户姓名',
              prop: 'customerName',
            },
            elConfig: {
              jsxRender: () => {
                const verifyFn = this.orderInfoJumpRender
                if (verifyFn && typeof verifyFn === 'function' && this?.judgePermission('driver_customer_list_detail')) {
                  return this.orderInfoJumpRender('customer')
                }
              },
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车牌号',
              prop: 'plateNo',
            },
            elConfig: {
              jsxRender: () => {
                const verifyFn = this.orderInfoJumpRender
                if (verifyFn && typeof verifyFn === 'function' && this?.judgePermission('vehicle_list_detail')) {
                  return this.orderInfoJumpRender('car')
                }
              },
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车系',
              prop: 'seriesName',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '车型',
              prop: 'modelName',
              width: 160,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '续约计租起止日期',
              prop: 'rentDate', // startDate 、endDate
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '每期租金',
              prop: 'rentAmount',
              width: 110,
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '押金',
              prop: 'totalDeposit',
            },
          },
        ],
        model: {
          customerName: '',
          plateNo: '',
          brandName: '',
          seriesName: '',
          modelName: '',
          rentDate: '',
          rentAmount: '',
          totalDeposit: '',
        },
      },
    }
  },
}
